/**
 * Lightweight configuration fetcher for the bootstrap bundle.
 * This only fetches configurations without importing the store,
 * keeping the bootstrap bundle small.
 *
 * The store operations (setting config, cohortId, etc.) are handled
 * in startFullWidget.ts when the full widget loads.
 */

import fetchConfiguration from '@/configuration/fetchConfiguration';
import fetchDynamicConfiguration from '@/configuration/fetchDynamicConfiguration';
import type { DynamicConfiguration, InitConfiguration, ServerConfiguration } from '@/domain/configuration';
import { logger } from '@/lib/logger';

export interface FetchAppConfigurationResult {
  serverConfiguration: ServerConfiguration;
  dynamicConfiguration: DynamicConfiguration;
}

export default async function fetchAppConfiguration(
  cdn: string,
  initConfig: InitConfiguration,
): Promise<FetchAppConfigurationResult> {
  logger.log('fetchAppConfiguration() called');

  const [serverConfiguration, dynamicConfiguration] = await Promise.all([
    fetchConfiguration(cdn, initConfig.appId),
    fetchDynamicConfiguration(cdn, initConfig.appId),
  ]);

  logger.log('fetchAppConfiguration() completed successfully');

  return {
    serverConfiguration,
    dynamicConfiguration,
  };
}
